import { render, staticRenderFns } from "./Blueshift.vue?vue&type=template&id=bc9736ba"
import script from "./Blueshift.vue?vue&type=script&lang=js"
export * from "./Blueshift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports